<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      videoinfo: {}, //考试的信息详情
    };
  },
  components: {
    Paperlist: () => import("./page.vue"),
    isedit: () => import("./papertestbank/index.vue"), // 添加
    TheEditor: () =>
      import("../theonlineTest/published/components/editorpaper/index.vue"), // 编辑
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "Paperlist";
        case 1:
          return "isedit";
        case 2:
          return "TheEditor";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        console.log("新增返回");
        this.$children[0].Buriedpoint({
          code: "PaperTest:Paperlist:add",
          parent_code: "PaperTest:Paperlist",
        });
      } else if (index == "0" && this.isActive == "2") {
        // 编辑
        this.$children[0].Buriedpoint({
          code: "PaperTest:Paperlist:edit",
          parent_code: "PaperTest:Paperlist",
        });
      }
      this.isActive = index;
    },
  },
};
</script>